import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./homecss/homenavtwo.css";
import MediaQuery from 'react-responsive'
import { BsInstagram, BsFacebook, BsFillPhoneFill, BsEnvelopeFill } from "react-icons/bs";
import { CgMenuGridR } from "react-icons/cg";
import { AiOutlineClose } from "react-icons/ai";
import { useModelTab } from "../../Blc_Business/BlcHomeLandingPage/HomeWindowTwo";
import { useBlcNavScroll } from "../../Blc_Business/BlcHomeLandingPage/HomeWindowThree";


export function HomeNavTwoPh(props) {
  const myUse = useModelTab();
  // const blcScroll = useBlcNavScroll()

  const [active, setActive] = useState('default');

  // hide navbar on scroll down and show on scroll up 
  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', () => {
    if (lastScrollY < window.scrollY) {
      document.getElementById('homeNavTwoPh').classList.add('hidePhNav');
    }
    else {
      document.getElementById('homeNavTwoPh').classList.remove('hidePhNav');
    }
    lastScrollY = window.scrollY;
  });


  return (
    <>
      <Navbar id="homeNavTwoPh" style={{ transition: '1s ease' }} variant="dark" fixed='top' bg='dark' expand={false}  >
        <Container className="nav-color" fluid >
          <Container className="d-flex justify-content-end">
            <div style={{ color: 'white', fontSize: '12px' }} className='mb-2'>
              <b>Tel:</b> <MediaQuery maxWidth={420}>  <a className="link-color" href="tel:+88 01313407157 " rel="noopener noreferrer" target="_blank">&nbsp; <BsFillPhoneFill size={16} /> </a> &nbsp;</MediaQuery>
              <MediaQuery minWidth={421}> <a className="link-color" href="tel:+88 01313407157 " rel="noopener noreferrer" target="_blank">&nbsp; {props.navDataLg.tel} </a> &nbsp;</MediaQuery>

              <b>E-mail:</b><MediaQuery maxWidth={420}> <a className="link-color" href="mailto: blc.communications@brac.net" rel="noopener noreferrer" target="_blank">&nbsp; <BsEnvelopeFill size={16} /> </a> &nbsp;</MediaQuery>
              <MediaQuery minWidth={421}> <a className="link-color" href="mailto: blc.communications@brac.net" rel="noopener noreferrer" target="_blank">&nbsp; {props.navDataLg.mail} </a> &nbsp; &nbsp;</MediaQuery>

              <b>Follow Us:</b>
              <a className="social-link" href="https://www.facebook.com/BLC.BRAC" rel="noopener noreferrer" target="_blank">&nbsp;&nbsp;<BsFacebook size={16} /></a>
              <a className="social-link" href="https://www.instagram.com/accounts/login/?next=/blc.brac/" rel="noopener noreferrer" target="_blank">&nbsp;&nbsp;<BsInstagram size={16} /></a>
            </div>
          </Container>
        </Container>
        <Container className="phNav" fluid>
          <Link to="/">
            <Navbar.Brand href="#">
              <img
                width="150"
                height="58"
                alt=""
                src={props.navDataLg[0].logo}
                className="d-inline-block align-top"
              />
            </Navbar.Brand>
          </Link>
          <Navbar.Toggle
            aria-controls="offcanvasNavbar"
            onClick={() => myUse[1](true)}
          ><CgMenuGridR size={30} /></Navbar.Toggle>

          <Navbar.Offcanvas
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="start"
            show={myUse[0]}
          >
            <Offcanvas.Header >
              <Offcanvas.Title id="offcanvasNavbarLabel">
                <img
                  width="150"
                  height="58"
                  alt=""
                  src={props.navDataLg[0].logo}
                  className="d-inline-block align-top"
                />
              </Offcanvas.Title>
              <AiOutlineClose size={25} style={{ color: 'lightgray' }} closeButton onMouseEnter={() => myUse[1](false)} />
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav activeKey={active}
                onSelect={(selectedKey) => setActive(selectedKey)}
                className="justify-content-end flex-grow-1 pe-3">
                <Link
                  to="/home"
                  eventKey="home"
                  className="blcnavtwo"
                  onClick={() => myUse[1](!myUse[0])}
                >
                  <h6 className="homeNavtext">{props.navFeature[0].blc_feature_name}</h6> <hr style={{ color: 'grey' }} />
                </Link>
                <Link
                  to="/locations"
                  className="blcnavtwo"
                  onClick={() => myUse[1](!myUse[0])}
                >
                  <h6 className="homeNavtext">{props.navFeature[1].blc_feature_name}</h6> <hr style={{ color: 'grey' }} />
                </Link>

                <Link
                  to="/facilities"
                  eventKey="facilities"
                  className="blcnavtwo"
                  onClick={() => myUse[1](!myUse[0])}
                >
                  <h6 className="homeNavtext">
                    {props.navFeature[2].blc_feature_name} <hr style={{ color: 'grey' }} />
                  </h6>
                </Link>
                <Link
                  to="/gallery"
                  eventKey="gallery"
                  className="blcnavtwo"
                  onClick={() => myUse[1](!myUse[0])}
                >
                  <h6 className="homeNavtext">{props.navFeature[3].blc_feature_name}</h6> <hr style={{ color: 'grey' }} />
                </Link>
                <Link
                  to="/allnews"
                  eventKey="allnews"
                  className="blcnavtwo"
                  onClick={() => myUse[1](!myUse[0])}
                >
                  <h6 className="homeNavtext">Blogs</h6> <hr style={{ color: 'grey' }} />
                </Link>
                <Link
                  to="/reservation"
                  eventKey="reservation"
                  className="blcnavtwo"
                  onClick={() => myUse[1](!myUse[0])}
                >
                  <h6 className="homeNavtext">{props.navFeature[4].blc_feature_name}</h6> <hr style={{ color: 'grey' }} />
                </Link>
                <Link
                  to="/faq"
                  eventKey="faq"
                  className="blcnavtwo"
                  onClick={() => myUse[1](!myUse[0])}
                >
                  <h6 className="homeNavtext">{props.navFeature[5].blc_feature_name}</h6> <hr style={{ color: 'grey' }} />
                </Link>

                <Link
                  to="/contact"
                  eventKey="contact"
                  className="blcnavtwo"
                  onClick={() => myUse[1](!myUse[0])}
                >
                  <h6 className="homeNavtext">{props.navFeature[6].blc_feature_name}</h6> <hr style={{ color: 'grey' }} />
                </Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </>
  );
}